"use client";

import { SessionProvider } from "next-auth/react";
import { TokenStorage } from "@/components/auth/TokenStorage";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <TokenStorage />
      {children}
    </SessionProvider>
  );
}

